import { addLegacyFinancialAliases, getFinancialValue, toNumber } from './obracunFields';

const MERGE_FIELDS = [
  'fee',
  'tax',
  'glovoTax',
  'rent',
  'renta',
  'petrol',
  'gorivo',
  'acom',
  'appKnjig',
  'utility',
  'struja',
  'sim',
  'doprinosi',
  'advance',
  'akontacija',
  'bonus',
  'ostalo',
  'rentSmjestaj',
  'oprema',
  'tarifa',
  'depozit',
  'napomena',
];

function fieldIsSet(obj, key) {
  const v = obj?.[key];
  return v !== undefined && v !== null && v !== '';
}

/** Spoji stare zapise (period 1 + 2) u jedan mjesecni prikaz */
export function mergeLegacyUserPeriodDocs(docs = []) {
  if (!docs.length) return null;
  if (docs.length === 1) return docs[0];

  const sorted = [...docs].sort((a, b) => {
    const pa = Number(a.period) || 0;
    const pb = Number(b.period) || 0;
    return pb - pa;
  });

  const merged = { ...sorted[0] };
  merged._legacyPeriodDocs = sorted.map((d) => d.id);

  for (const key of MERGE_FIELDS) {
    for (const doc of sorted) {
      if (fieldIsSet(doc, key)) {
        merged[key] = doc[key];
        break;
      }
    }
  }

  return merged;
}

export function buildUserPeriodDataMap(snapshotDocs) {
  const byUser = {};
  snapshotDocs.forEach((docSnap) => {
    const docData = addLegacyFinancialAliases(docSnap.data());
    const uid = docData.userId;
    if (!uid) return;
    if (!byUser[uid]) byUser[uid] = [];
    byUser[uid].push({ id: docSnap.id, ...docData });
  });

  const data = {};
  Object.entries(byUser).forEach(([uid, list]) => {
    data[uid] = mergeLegacyUserPeriodDocs(list);
  });
  return data;
}

/** Mjesecni override nad default vrijednostima osobe */
export function resolveMonthlyFinancials(person, monthlyDoc) {
  if (!monthlyDoc) return person;
  const merged = { ...person };
  for (const key of MERGE_FIELDS) {
    if (fieldIsSet(monthlyDoc, key)) merged[key] = monthlyDoc[key];
  }
  return merged;
}

export function getMonthlyScalar(person, monthlyDoc, fieldName) {
  if (monthlyDoc && fieldIsSet(monthlyDoc, fieldName)) return toNumber(monthlyDoc[fieldName]);
  return toNumber(person[fieldName]);
}

export function getMonthlyFinancial(person, monthlyDoc, canonicalKey) {
  return getFinancialValue(resolveMonthlyFinancials(person, monthlyDoc), canonicalKey);
}
